import Swiper, { Autoplay, Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Autoplay, Lazy, Navigation, Pagination, Scrollbar]);

// ===============================================================
// BUSCA DADOS DE COMPRA UM PRODUTO
// ===============================================================
export async function getProductData(id) {

  if (window.productVariants[id]) {
    return {success: true, data: window.productVariants[id] }
  }

  try {
    const response = await fetch(`/produto/preco/${id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })

    if (!response.ok) {
      console.error(`Erro ao buscar dados do produto de ID ${id}:\n${response.statusText}`)
      return { success: false, data: null }
    }

    const data = await response.json()

    window.productVariants[id] = data
    return { success: true, data }

  } catch (error) {
    console.error(`Erro na execução da busca dos dados do produto de ID ${id}:\n`, error)
    return { success: false, data: null }
  }
}

// ===============================================================
// ADIÇÃO MANUAL DE ASSET
// ===============================================================
// Usado para incluir assets no código de forma manual, conforme a necessidade
export function addAsset(source, onloadCallback) {

  if (!source || source === '') return console.error(`addAsset: caminho não definido.`)

  if (source.includes('.js')) {
    const scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', source);

    if (onloadCallback && typeof onloadCallback === 'function') {
      scriptTag.onload = onloadCallback
    }

    return document.body.appendChild(scriptTag)

  } else if (source.includes('.css')) {
    const linkTag = document.createElement('link')
    linkTag.setAttribute('rel', 'stylesheet')
    linkTag.setAttribute('type', 'text/css')
    linkTag.setAttribute('href', source)
    return document.head.appendChild(linkTag)

  } else {
    const error = `addAsset: Erro ao criar o asset. Tipo de script não definido, ou não possui tratamento para este tipo de asset.`
    return console.error(error, source)
  }
}

// ===============================================================
// BUSCA O CARRINHO ATIVO
// ===============================================================
export async function getCart() {
  try {
    const response = await fetch('/carrinho', {
      headers: {
        'Accept': 'application/json'
      }
    });

    return await response.json()

  } catch (error) {
    console.error('Erro ao buscar os dados do carrinho');
    console.error(error);
    return false
  }
}

// ===============================================================
// SERIALIZE ARRAY
// ===============================================================
export function serializeArray(form) {
  const formData = new FormData(form);
  const data = {};

  for (const [name, value] of formData) {
    data[name] = value;
  }

  let formBody = [];

  for (const key in data) {
    const encodeKey = encodeURIComponent(key);
    const encodeValue = encodeURIComponent(data[key]);
    formBody.push(`${encodeKey}=${encodeValue}`);
  }

  return (formBody = formBody.join('&'));
}

// ===============================================================
// URL ENCODE FORM DATA
// ===============================================================
export function urlEncodeFormData(formData) {
  let string = '';

  function encode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }

  for (const pair of formData.entries()) {
    if (typeof pair[1] == 'string') {
      string += (string ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1]);
    }
  }
  return string;
}

// ===============================================================
// PREÇO POR AJAX
// ===============================================================
export function getPriceProd() {
  const attr = 'data-update-price';

  const priceEls = document.querySelectorAll(`[${attr}]`);
  if (priceEls.length > 0) {
    priceEls.forEach((priceEl) => {
      let observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            let prodId = priceEl.getAttribute(attr);
            let url = '/produto/preco/' + prodId;

            if (prodId != '' && prodId != null) {
              $.ajax({
                url: url,
                type: 'GET',
              })
                .done((resp) => {
                  priceEl.innerHTML = resp;
                })
                .fail((resp) => {
                  console.error('price error', resp);
                });
            }

            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(priceEl);
    });
  }
}

// ===============================================================
// DEBOUNCE
// ===============================================================
export function debounce(func, wait, immediate) {
  var timeout;
  immediate || (immediate = true);

  return function () {
    var context = this,
      args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

// ===============================================================
// THROTTLE
// ===============================================================
export function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

// ===============================================================
// FORMAT MONEY
// ===============================================================
export function formatMoney(value) {
  // FORMATA UM VALOR
  return (
    'R$ ' +
    value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
  );
}

// ===============================================================
// PRODUCTS CAROUSEL
// ===============================================================
export function setProducts() {
  const swiperEls = document.querySelectorAll('[data-products]');
  if (swiperEls.length > 0)
    swiperEls.forEach((swiperEl) => {
      new Swiper(swiperEl, {
        watchOverflow: true,
        speed: 700,
        watchSlidesProgress: true,
        loop: false,
        simulateTouch: true,
        spaceBetween: 16,
        slidesPerView: 2,
        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          992: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
          1440: {
            spaceBetween: 16,
            slidesPerView: 5,
          },
        },
        navigation: {
          prevEl: swiperEl.parentElement.parentElement.querySelector('.-prev'),
          nextEl: swiperEl.parentElement.parentElement.querySelector('.-next'),
          disabledClass: '-disabled',
        },
        pagination: {
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: '-active',
          el: swiperEl.parentElement.parentElement.querySelector('.pagination'),
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
        // swiper lazy load
        preloadImages: false,
        watchVisibility: true,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true,
        },
      });
    });
}

// ===============================================================
// PRODUCTS BLOCKS
// ===============================================================
export function setBlocks() {
  const products = document.querySelectorAll('[data-product-block]');
  if (products.length > 0)
    products.forEach((product) => {
      let swiperEl = product.querySelector('[data-product-thumbs]');
      if (swiperEl)
        new Swiper(swiperEl, {
          speed: 700,
          loop: false,
          watchOverflow: true,
          simulateTouch: true,
          watchSlidesProgress: true,
          spaceBetween: 8,
          slidesPerView: 3,
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: true,
          },
        });

      let images = product.querySelectorAll('[data-product-block-image]');
      let thumbs = product.querySelectorAll('[data-product-block-thumb]');
      if (images.length > 0 && thumbs.length > 0)
        thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => {
            images.forEach((img) => {
              img.classList.remove('-active');
            });
            thumbs.forEach((t) => {
              t.classList.remove('-active');
            });

            images[i].classList.add('-active');
            thumbs[i].classList.add('-active');
          });
        });
    });
}

// ===============================================================
// PRODUCT PURCHASE SCRIPT
// ===============================================================
export function initPurchase() {
  const products = document.querySelectorAll('[data-product-purchase]');
  if (products.length > 0) {
    var hasScript = false;
    products.forEach((product) => {
      let observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            if (!hasScript) {
              hasScript = true;

              let newScript = document.createElement('script');
              newScript.src = window.productPurchaseJs;
              document.body.appendChild(newScript);

              console.log('productPurchase.js');
            }
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(product.closest('[data-product-box]'));
    });
  }
}

// ===============================================================
// CLIENT ACCESS
// ===============================================================
export async function getClient() {
  try {
    let response = await fetch('/conta/cliente', {
      headers: {
        accept: 'application/json',
      },
    });
    let client = await response.json();
    let access = Object.keys(client).length > 0;

    console.log('client utilities', client);

    if (access) return client;
    if (!access) return false;
  } catch (error) {
    console.error(`getClient error`, error);
  }
}

// ===============================================================
// VERIFICA TAG DO CLIENTE AO CARREGAR A PÁGINA
// ===============================================================
export async function verifyClientAccess(){
  if (window.Client && typeof window.Client.getClient === 'function' && typeof window.Client.syncCatalogVisibility === 'function') {
    const client = await window.Client.getClient();
    const hasAccess = window.Client.hasCatalogAccess(client);
    window.Client.syncCatalogVisibility(hasAccess);
  }
}

// ===============================================================
// SEARCH CONTROL
// ===============================================================
export function setSearch() {
  const search = document.querySelector('[data-search]');
  const toggle = document.querySelector('[data-toggle-search]');
  if (search && toggle)
    toggle.addEventListener('click', () => {
      search.classList.toggle('-active');
      if (search.classList.contains('-active'))
        setTimeout(() => {
          search.querySelector('input[name="q"]').focus();
        }, 250);
    });
}

// ===============================================================
// HEADER SCROLL ANIMATION
// ===============================================================
export function setScroll() {
  const header = document.querySelector('[data-header].-fixed');
  if (header)
    window.addEventListener('scroll', () => {
      window.scrollY > 0 ? header.classList.add('-scroll') : header.classList.remove('-scroll');
    });
}
